export default theme => ({
  card: {
    paddingTop: 0,
  },
  content: {
    paddingTop: 0,
  },
  header: {
    paddingTop: 5,
    paddingBottom: 0,
    width: "100%",
  },
});
